import getInsertionSortAnnimatio from "../SortingVisualizer/InsertionSortAlgorithm";
import classes from "../SortingVisualizer/SortingVisualizer.module.css";
function backtonormal() {
  const resetbtn = document.getElementById("reset_btn");
  const inputs = document.getElementById("inputs");
  const quicksort = document.getElementById("QuickSort");
  const mergesort = document.getElementById("MergeSort");
  const bubblesort = document.getElementById("BubbleSort");
  const insertionsort = document.getElementById("InsertionSort");
  quicksort.classList.remove(`${classes.disable}`);
  mergesort.classList.remove(`${classes.disable}`);
  bubblesort.classList.remove(`${classes.disable}`);
  insertionsort.classList.remove(`${classes.selected}`);
  inputs.classList.remove(`${classes.disable}`);
  resetbtn.classList.remove(`${classes.disable}`);
}
export default function InsertionSort({ array, speed }) {
  const animations = getInsertionSortAnnimatio(array);
  const ANNIMATION_S = Math.floor(200 - 5 * speed);
  const PRIMARY_COLOR = "turquoise";
  const SECONDRY_COLOR = "red";

  for (let i = 0; i < animations.length; i++) {
    const arrayBars = document.getElementsByClassName("array-bar");
    const [barOneIdx, barTwoIdx, height1, height2] = animations[i];
    const barOneStyle = arrayBars[barOneIdx].style;
    const barTwostyle = arrayBars[barTwoIdx].style;
    setTimeout(() => {
      barOneStyle.backgroundColor = "blue";
      barTwostyle.backgroundColor = SECONDRY_COLOR;
      barOneStyle.height = `${height2}px`;
      barTwostyle.height = `${height1}px`;
      setTimeout(() => {
        barOneStyle.backgroundColor = PRIMARY_COLOR;
        barTwostyle.backgroundColor = PRIMARY_COLOR;
      }, ANNIMATION_S);
      if (i === animations.length - 1) {
        backtonormal();
      }
    }, i * ANNIMATION_S);
  }
}
